<script setup lang="ts">
  import FigmaAwareBadge from '@/shared/assets/icons/FigmaAwareBadge.svg';
  import FigmaUnawareBadge from '@/shared/assets/icons/FigmaUnawareBadge.svg';

  interface Recipient {
    memberId: number;
    userId: number;
    name: string;
    acknowledged: boolean;
  }

  interface Props {
    noticeId: number;
    isLoading: boolean;
    errorMessage: string | null;
    recipients: Recipient[];
  }

  defineProps<Props>();
</script>

<template>
  <tr
    v-if="isLoading || errorMessage || recipients.length === 0"
    class="border-b border-gray-02 bg-gray-09"
    data-testid="recipients-expanded-row"
  >
    <td
      colspan="10"
      class="px-4 py-2 text-center"
    >
      <p
        v-if="isLoading"
        class="text-xs text-gray-04"
      >
        Carregando destinatários...
      </p>
      <p
        v-else-if="errorMessage"
        class="text-xs text-red-17"
      >
        {{ errorMessage }}
      </p>
      <p
        v-else
        class="text-xs text-gray-04"
      >
        Nenhum destinatário encontrado.
      </p>
    </td>
  </tr>

  <tr
    v-for="recipient in !isLoading && !errorMessage ? recipients : []"
    :key="`recipient-row-${noticeId}-${recipient.memberId}`"
    class="border-b border-gray-02 bg-gray-09"
    data-testid="recipients-expanded-row"
  >
    <td class="px-4 py-2" />
    <td class="px-4 py-2" />
    <td class="px-4 py-2" />
    <td class="px-4 py-2" />
    <td class="px-4 py-2" />

    <td class="px-4 py-2 align-middle">
      <p class="flex h-8 items-center truncate text-xs text-gray-07">
        {{ recipient.name }}
      </p>
    </td>

    <td class="px-4 py-2 align-middle">
      <div class="flex h-8 items-center justify-center">
        <component
          :is="recipient.acknowledged ? FigmaAwareBadge : FigmaUnawareBadge"
          class="block h-5 w-6"
        />
      </div>
    </td>

    <td class="px-4 py-2" />
    <td class="px-4 py-2" />
    <td class="px-4 py-2" />
  </tr>
</template>
